import { Link } from "react-router-dom";
import {
  Loader2, CreditCard, XCircle, RefreshCw, ArrowUpRight, ArrowDownCircle,
} from "lucide-react";

export default function PlanSummary({ sub, busy, onOpenPortal, onCancel, onResume, onDowngradeFree }) {
  const s = sub?.subscription;
  const plan = sub?.plan_detail;
  const isFree = sub?.effective_plan === "free";
  const canceled = s?.status === "canceled";
  const periodEnd = s?.current_period_end ? new Date(s.current_period_end).toLocaleDateString() : null;

  return (
    <div className="rounded-xl border border-slate-200 bg-white p-6">
      <div className="flex flex-wrap items-start justify-between gap-4">
        <div>
          <span className="text-xs font-semibold uppercase tracking-wider text-slate-400">Current plan</span>
          <div className="flex items-center gap-3 mt-1">
            <h2 className="font-heading text-2xl font-bold text-[#0A0F1C]">{plan?.display_name || plan?.name || "Free"}</h2>
            {canceled ? (
              <span className="text-xs font-medium px-2.5 py-1 rounded-full bg-amber-100 text-amber-700" data-testid="sub-status-canceled">Canceling</span>
            ) : (
              <span className="text-xs font-medium px-2.5 py-1 rounded-full bg-green-100 text-green-700" data-testid="sub-status-active">Active</span>
            )}
          </div>
          {!isFree && periodEnd && (
            <p className="text-sm text-slate-500 mt-1">
              {canceled ? "Access until" : "Renews on"} <span className="font-mono">{periodEnd}</span> · billed {s?.billing_cycle}
            </p>
          )}
          {isFree && <p className="text-sm text-slate-500 mt-1">Up to 3 AI matches · basic features</p>}
        </div>
        <div className="flex flex-wrap gap-2">
          <Link to="/pricing" data-testid="billing-change-plan" className="h-10 px-4 rounded-md bg-[#2563EB] text-white text-sm font-medium flex items-center gap-1.5 hover:bg-[#1D4ED8] transition-colors">
            {isFree ? "Upgrade plan" : "Change plan"} <ArrowUpRight size={15} />
          </Link>
          {!isFree && (
            <button onClick={onOpenPortal} disabled={busy === "portal"} data-testid="billing-manage-portal"
              className="h-10 px-4 rounded-md border border-slate-300 text-sm font-medium flex items-center gap-1.5 hover:bg-slate-50 transition-colors disabled:opacity-60">
              {busy === "portal" ? <Loader2 className="animate-spin" size={15} /> : <CreditCard size={15} />} Manage billing
            </button>
          )}
        </div>
      </div>

      {!isFree && (
        <div className="mt-5 pt-5 border-t border-slate-100 flex flex-wrap gap-2">
          {canceled ? (
            <button onClick={onResume} disabled={busy === "resume"} data-testid="billing-resume"
              className="h-10 px-4 rounded-md bg-[#16A34A] text-white text-sm font-medium flex items-center gap-1.5 hover:bg-green-700 transition-colors disabled:opacity-60">
              {busy === "resume" ? <Loader2 className="animate-spin" size={15} /> : <RefreshCw size={15} />} Resume subscription
            </button>
          ) : (
            <button onClick={onCancel} disabled={busy === "cancel"} data-testid="billing-cancel"
              className="h-10 px-4 rounded-md border border-red-200 text-red-600 text-sm font-medium flex items-center gap-1.5 hover:bg-red-50 transition-colors disabled:opacity-60">
              {busy === "cancel" ? <Loader2 className="animate-spin" size={15} /> : <XCircle size={15} />} Cancel subscription
            </button>
          )}
          <button onClick={onDowngradeFree} disabled={busy === "free"} data-testid="billing-downgrade-free"
            className="h-10 px-4 rounded-md border border-slate-300 text-slate-600 text-sm font-medium flex items-center gap-1.5 hover:bg-slate-50 transition-colors disabled:opacity-60">
            {busy === "free" ? <Loader2 className="animate-spin" size={15} /> : <ArrowDownCircle size={15} />} Switch to Free
          </button>
        </div>
      )}
    </div>
  );
}
